export interface Bonus {
  index: string
  title: string
  body: string
  value: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    index: '01',
    title: 'Cómo armar tu propia prensa casera',
    body: 'Medidas, materiales de ferretería y el orden exacto de las capas para que la presión sea uniforme. La misma prensa que se vende hecha, armada por vos, y con capacidad para varias flores a la vez.',
    value: 'Valor $8.900',
    image:
      'https://cdn.magicpatterns.com/uploads/oP3o9rPsDxonGWmnnwKUPS/COMO_CREAR_LA_PRENSA.png',
  },
  {
    index: '02',
    title: 'Calendario estacional de flores',
    body: 'Qué se junta en primavera, verano, otoño e invierno y en qué momento del día cortar cada especie. Para tener material listo antes de la temporada de regalos, en vez de salir a buscar cuando ya no hay.',
    value: 'Valor $6.900',
    image:
      'https://cdn.magicpatterns.com/uploads/tkgLDeU3TVGScqFVAPWwuo/CALENDARIO_ESTACIONAL.png',
  },
  {
    index: '03',
    title: 'Diccionario de significado de flores',
    body: 'Más de 100 flores y plantas con su simbolismo, para armar regalos y tarjetas que dicen algo concreto. La rosa, la lavanda y el pensamiento no significan lo mismo, y quien lo recibe lo nota.',
    value: 'Valor $7.900',
    image:
      'https://cdn.magicpatterns.com/uploads/crvhqebJ4LdnieDYkY5gf1/DICCIONARIO_DE_FLORES.png',
  },
  {
    index: '04',
    title: 'Kit imprimible: registro de herbario',
    body: 'Fichas de archivo botánico listas para imprimir y completar: especie, fecha, lugar, método usado y notas. Así sabés exactamente qué funcionó y podés repetirlo cuando quieras.',
    value: 'Valor $5.900',
    image:
      'https://cdn.magicpatterns.com/uploads/hnHWKmh7XputoqX8c5Pebe/IMPRIMIBLE_-_REGISTRO_DE_HERBARIO.png',
  },
]

export const bonusTotalValue = '$29.600'
